export default __webpack_public_path__ + "static/media/330_dummy2016-illustrator01-mobile-de.6d92529a.png";